import * as React from 'react';
/**
 *
 * Original name: play circle
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29939%3A6997
 *
 */
export const PlayCirclePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M42.5 32 26 42.5v-21L42.5 32Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 56.083c-16.15 0-24-7.85-24-24s7.85-24 24-24 24 7.85 24 24-7.85 24-24 24Zm0-4c-7.487 0-12.276-1.82-15.228-4.772S12 39.571 12 32.083c0-7.487 1.82-12.275 4.772-15.227 2.953-2.953 7.74-4.773 15.228-4.773 7.487 0 12.276 1.82 15.228 4.772C50.18 19.808 52 24.596 52 32.084s-1.82 12.276-4.772 15.228c-2.953 2.953-7.74 4.772-15.228 4.772Z", fill: "currentColor" })));
